import React from 'react';
import PropTypes from 'prop-types';
import values from 'lodash.values';
import ListHeader from '../ListHeader';
import Topic from './Topic';
import styles from './topics.module.scss';

const Topics = ({categories}) => (
  <div>
    <ListHeader eyebrow="Browse by topic" text="Find answers by topic" />
    <div className={styles.Topics}>
      {values(categories).map(category => (
        <Topic category={category} key={category.id} />
      ))}
    </div>
  </div>
);

Topics.propTypes = {
  categories: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      articleCount: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      description: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default Topics;



// WEBPACK FOOTER //
// ./src/components/topics/index.js